// Member :
export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
export const FETCH_INFO = 'FETCH_INFO';
export const USER_MODIFY = 'USER_MODIFY';
export  const RESET_MEMBER = "RESET_MEMBER"

// Agency :
export const SET_AGENCY = 'SET_AGENCY';

// news :
export const NEWS_IMG = 'NEWS_IMG';
export const NEWS_IMG_CLOSE = 'NEWS_IMG_CLOSE';

// Navigation :
export const NEXT_NAVIGATION_STEP_ONE = 'NEXT_NAVIGATION_STEP_ONE';
export const NEXT_NAVIGATION_STEP_TWO = 'NEXT_NAVIGATION_STEP_TWO';
export const NEXT_NAVIGATION_STEP_TREE = 'NEXT_NAVIGATION_STEP_TREE';
export const NEXT_NAVIGATION_STEP_FOUR= 'NEXT_NAVIGATION_STEP_FOUR';
export  const  PROGRESS_CHANGE='PROGRESS_CHANGE';
export  const  PROGRESS_CHANGE_NO='PROGRESS_CHANGE_NO';

//insurance
export const STEP_TREE="STEP_TREE";
export const OLD_DATA="OLD_DATA";
export const OLD_DATA_OFF="OLD_DATA_OFF";
export const CALCULATE="CALCULATE";
export const  CHANGE_OLD_INSURANCE = 'CHANGE_OLD_INSURANCE';
export const  LOAD_LAST_ORDER = "LOAD_LAST_ORDER"

//intro
export const SELECT_TAB ="SELECT_TAB";



export const SETTING_CHANGE_blogExpanded = 'SETTING_CHANGE_blogExpanded';
export const BLOG_IN_HEADER = 'BLOG_IN_HEADER';
export const EXPANDED_IN_HEADER = 'EXPANDED_IN_HEADER';


export  const FILTER_COMPANY = "FILTER_COMPANY"

export  const TYPE_OF_POST = "TYPE_OF_POST"

export  const TOKEN = "TOKEN"
export  const INITIAL = "INITIAL"
export  const CALC_OBJECT = "CALC_OBJECT"


